// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

require('font-awesome/css/font-awesome.css')
require('font-awesome-animation/dist/font-awesome-animation.css')
require('froala-editor/js/froala_editor.pkgd.min');
require("froala-editor/css/froala_editor.pkgd.min.css");
require('froala-editor/css/froala_style.min.css')
require('froala-editor/js/languages/pt_br')
window._ = require('lodash');

import '@fortawesome/fontawesome-free/css/all.min.css';

import Vue from 'vue';
import App from './app';
import router from './router';
import store from './store';
import localStorage from 'vue-localstorage';
import BootstrapVue from 'bootstrap-vue'
import element from 'element-ui'
import VueEvents from 'vue-events'
import 'assets/theme/index.css'
import locale from 'element-ui/lib/locale/lang/pt-br'

import VueFroala from 'vue-froala-wysiwyg'
import CompositionApi from '@vue/composition-api'
//import 'mdbvue/lib/css/mdb.min.css'

const isAsoSignatureFlow = /\/funcionario\/aso\/assinar\//.test(window.location.pathname)
let vuetify = null

if (isAsoSignatureFlow) {
  const vuetifyModule = require('./plugins/vuetify')
  vuetify = vuetifyModule.default || vuetifyModule
}

Vue.use(VueFroala)
Vue.use(CompositionApi)
Vue.use(localStorage)
Vue.use(BootstrapVue)
Vue.use(element,{locale});
Vue.use(VueEvents);
Vue.use(router);


//SERVICES
import './services'

//DIRECTIVE
import './directive'

//PLUGINS
// import './plugins'

$('.carregando').show();

new Vue({
  el: '#app',
  router,
  store,
  vuetify,
  localStorage,
  element,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js